<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0"> 
    <div  >
      <van-form  
          @submit="onSubmit"
          @failed="onFailed"
      >
        <van-cell-group>
          <van-field name="radio" label="业务板块"
            v-model="formData.type_name"
              :rules="[{ required: true, message: '请选择业务类型' }]"
                     input-align="right">
            <template #input>
              <van-radio-group v-model="formData.type_name" direction="horizontal">
                <van-radio checked-color="#ffb01b" name="竞赛">竞赛</van-radio>
                <van-radio checked-color="#ffb01b" name="培训">培训</van-radio>
                <van-radio checked-color="#ffb01b" name="星级俱乐部">星级俱乐部</van-radio>
                <van-radio checked-color="#ffb01b" name="七彩星级">七彩星级</van-radio>
                <van-radio checked-color="#ffb01b" name="其他">其他</van-radio>
              </van-radio-group>
            </template>
          </van-field> 


          <van-field name="radio" label="是否匿名"
                     input-align="right">
            <template #input>
              <van-radio-group v-model="formData.niming" direction="horizontal">
                <van-radio checked-color="#ffb01b" :name="1">匿名</van-radio>
                <van-radio checked-color="#ffb01b" :name="2">实名</van-radio> 
              </van-radio-group>
            </template>
          </van-field>
            
        <van-field
                v-model="formData.content"
                rows="2"
                autosize
                :rules="[{ required: true, message: '请输入意见或建议' }]"
                type="textarea"
                maxlength="500"
                placeholder="请输入您的意见或建议..."
                show-word-limit
        />
         

        </van-cell-group>

        <div class="savebtn">
          <van-button
              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
              style="width: 3rem"
              size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
            提交申请
          </van-button>
        </div>
        
      </van-form>

   
    </div>
    <LoginDialog
      :show="loginShow"
      @loginSuccess="loginSuccess"
      @loginCancel="loginCancel"
    />
      <van-dialog
        v-model="showNotice" 
        title="信箱@CCA" 
        confirm-button-text="信箱入口"
        @confirm="showNotice=false"
        @cancel="back()"
        :show-cancel-button="true"
        cancel-button-text="取消"
        >
        <div class="notice_content">
<p>欢迎您@CCA。您对啦啦操竞赛、培训、星级俱乐部、七彩星级有什么感受？您对啦啦操项目推广及未来发展有何高招与高见？啦啦操离不开大家的真知灼见。</p>
<p>您的留言将被转给有关业务部门和地方，并可能以不同形式公开。</p>
<p>汲取各方智慧，倾听阁下意见，采纳诸君建议。您对啦啦操的期望，也是我们努力的方向。</p>
        </div>
        </van-dialog>
  </div>
</template>
<style scoped>
.step-box {
  margin: 0 .2rem .2rem;
}

.step-two-box {
  padding: .4rem .2rem;
  font-size: 16px;
}
.notice_content{
    padding: 10px;
    text-align: left;
    line-height: 28px;
}
.notice_content p{
    text-indent:2em;
    margin-bottom: 1em;
}

.step-two-box li {
  margin-bottom: .3rem;
}


.step-three-title {
  font-size: 24px;
  padding: .3rem 0;
  text-align: center;
}

.step-three-text {
  margin: 0 .3rem;
  font-size: 14px;
}

.step-three-danwei {
  margin: .1rem 0 .3rem;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}

.gray-back>>>.van-dialog__message{
    text-align: le;
}

</style>
<script>
import Vue from 'vue'; 
import validator from "../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';
import SaiquPicker from '@/components/picker/SaiquPicker.vue';

import {
  Cell,
  Field, 
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Dialog,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

import LoginDialog from "@/components/LoginDialog.vue";
Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Dialog).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'ClubApplyMine',
  components: {
    PicUploader, FileUploader, SaiquPicker,LoginDialog
  },
  data: function () {
    return {
      validator,
      active: 0,
      loading: false,
      showPay: false,
      saveLoading: false,
      showArea: false,
      showSaiquPicker: false,
      areaList: {},
      areaValue: '',
      loginShow:false,
      submitType: '',
      showNotice:false,
      formData: {
        id: 0,
        type_name: '',
        niming: 2,
        content: '',  
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;  
    document.title = "信箱@CCA" 
    this.getUserDetail();
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    getUserDetail() {
      let that = this;
      this.$api.get(
        "/api/user/userPage",
        {},
        (res) => {
          console.log(res); 
        that.showNotice= true;  
        },
        (res) => {
          if (res.code == 401 || res.code == 402) {
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false; 
    },

    loginCancel() {
      console.log("-------取消登录--------"); 
    },
    back(){
        rbLink({
                name:'',
            },'back')
    },
    onQuestion() {
      console.log('onQuestion')
    }, 
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;

 
      that.saveLoading = true;

    that.$api.post('/api/gbook/formadd', that.formData, (res) => {
        that.saveLoading = false;
        Toast.success('提交成功，感谢您的宝贵建议~');
        setTimeout(() =>{
          rbLink({
           name:'' 
          },'back')
        },1000)
    }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
    }) 
    },
 
    submit(values) {
      this.submitType = 'submit';
      this.submitThreeType = 'submit'
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
  
  }
}
</script>



// WEBPACK FOOTER //
// Gbook.vue?681d5a2c